module.exports = __webpack_public_path__ + "img/opening_hours.fa16c885.svg";